import React from 'react';
import styled, { css, keyframes } from 'styled-components'

/*
 *  @Description:   Component that renders a Loader
 */

const LoadingP = styled.p`
  margin-top: 20px;
  text-align: center;
  color: ${ props => props.fontColor };
`;

const LoadingDiv = styled.div`
  width: 80px;
  margin-left: auto;
  margin-right: auto;
  ${ props => props.extraStyle }
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const animation = css`
    animation: ${ rotate } 1s linear infinite;
`

const StyledLoader = styled.div`
  margin-left:auto;
  margin-right:auto;
  border-radius: 50%;
  display: ${ props => props.isLoading ? 'flex' : 'none' };
  border: ${ props => props.thickness && props.sColor ? props.thickness + 'px solid ' + props.sColor : props.thickness ? props.thickness + 'px solid #f3f3f3' : props.sColor ? '10px solid ' + props.sColor : '10px solid #f3f3f3' };
  border-top: ${ props => props.thickness && props.pColor ? props.thickness + 'px solid ' + props.pColor : props.thickness ? props.thickness + 'px solid #555' : props.pColor ? '10px solid ' + props.pColor : '10px solid #555' };
  height: ${ props => props.height ? props.height + 'px' : '50px' };
  width: ${ props => props.width ? props.width + 'px' : '50px' };
  ${ animation }
`;

const Loader = ( props ) => {
    const { primaryColor, secondaryColor, message, fontColor, extraStyle } = props;

    return (
        <LoadingDiv extraStyle={ extraStyle }>
            <StyledLoader
                pColor={ primaryColor }
                sColor={ secondaryColor }
                isLoading={ true }
                width={ 50 }
                heigh={ 50 }
            />
            <LoadingP fontColor={ fontColor }>{ message }</LoadingP>
        </LoadingDiv>
    )
}

export default Loader;